import React, { useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import Carousel from '../../../../components/Carousel';
import ViewEmailModal from '../../../InsuredProfilePage/components/modals/ViewEmailModal';

const SequenceDetails = ({ sequence }) => (
  <Box textAlign="left">
    <Carousel itemLabel="Step" items={sequence.emails}>
      {({ item }) => (
        <Box>
          <Text textAlign="center" textStyle="displayXxs">{item.step.name}</Text>
          <ViewEmailModal
            bg="gray.50"
            borderRadius="md"
            email={item.email}
            mt={4}
            p={4}
          />
        </Box>
      )}
    </Carousel>
  </Box>
);

SequenceDetails.propTypes = {
  automation: PropTypes.shape({}),
  sequence: PropTypes.shape({ emails: [{ body: PropTypes.string }] })
};

export default SequenceDetails;
